<template>
    <vx-card v-if="loading">
        <h3>Loading.. Please wait..</h3>
    </vx-card>
    <div v-else>
        <h3 class="mt-2 mb-3" v-if="issue_type == 'highway'">Corrective Maintenance Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'electrical_maintenance'">Electrical Maintenance Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'major_maintenance'">Major Maintenance Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'routine_maintenance'">Routine Maintenance Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'road_user_accident'">Road User Accident Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'occupational'" >Occupational Accident Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'hazard'">Hazard Accident Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'dead_animal_debris_removal'" >Dead Animal Debris Removal Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'vehicle_breakdown'" >Vehicle Breakdown Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'traffic_violation'">Unauthorised Median Cut Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'material_damage'">Material Damage Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'other'">Other Resolution</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'enroachment_row'">Enroachment Row Resolution</h3>

        <template v-if="hasPermission">

            <div v-if="issue.id" class="mb-3">
                <router-link :to="{name: 'issues-view', params: {issue_type: issue_type, issue_id: issue.id}}">
                    <vs-button type="filled" size="small" color="primary">View Issue</vs-button>
                </router-link>
            </div>
    
            <vs-row class="mt-base mb-3" v-if="issue.status == 'a'">
                <vs-col>
                    <strong>Note:</strong> This issue is Assigned to
                    <template v-if="issue.resource_allocation == 'e'">
                        {{ issue.allocated_resource.first_name }} {{ issue.allocated_resource.last_name }} (Vendor), 
                    </template>
                    {{ issue.allocated_engineer.first_name }} {{ issue.allocated_engineer.last_name }} (Employee).<br/>
                    <template v-if="issue.resolution_status_se">
                        Resolution Status (SE/PO):
                        <template v-if="issue.resolution_status_se == 'p'"><span class="text-warning font-bold">Pending.</span><br/></template> 
                        <template v-else-if="issue.resolution_status_se == 'r'">
                            <span class="text-danger font-bold">Rejected</span>, <span v-if="issue.resolution_se_by">(By: {{ issue.resolution_se_by.first_name }} {{ issue.resolution_se_by.last_name }}).</span> <br/>
                            <span><strong class="text-danger">Reject Reason:</strong> {{ issue.resolution_comment_se || "No Comment" }}.</span> <br/>
                        </template>
                        <template v-else-if="issue.resolution_status_se == 'a'">
                            <span class="text-success font-bold">Approved</span>, <span v-if="issue.resolution_se_by">(By: {{ issue.resolution_se_by.first_name }} {{ issue.resolution_se_by.last_name }}).</span> <br />
                        </template>
                    </template>
                    <template v-if="issue.resolution_status">
                        Resolution Status:
                        <template v-if="issue.resolution_status == 'p'"><span class="text-warning font-bold">Pending.</span><br/></template>
                        <template v-else-if="issue.resolution_status == 'r'">
                            <span class="text-danger font-bold">Rejected</span>, <span v-if="issue.resolution_by">(By: {{ issue.resolution_by.first_name }} {{ issue.resolution_by.last_name }}).</span> <br/>
                            <span><strong class="text-danger">Reject Reason:</strong> {{ issue.resolution_comment || "No Comment" }}</span> <br/>
                        </template>
                        <template v-else-if="issue.resolution_status == 'a'">
                            <span class="text-success font-bold">Approved</span>, <span v-if="issue.resolution_by">(By: {{ issue.resolution_by.first_name }} {{ issue.resolution_by.last_name }}).</span> <br/>
                        </template>
                    </template>
                    <template v-if="issue.resolution_ended_on && ['p', 'r'].includes(issue.resolution_status)">
                        Resolution End Date: <FormatText :text="issue.resolution_ended_on" format="date" />
                    </template>
                </vs-col>
            </vs-row>

            <vx-card noShadow noRound>
                <HighwayResolution :mode="mode" v-if="issue_type == 'highway'" :issue.sync="issue" :api_errors="api_errors" 
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <HazardResolution :mode="mode" v-else-if="issue_type == 'hazard'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <ElectricalMaintenanceResolution :mode="mode" v-else-if="issue_type == 'electrical_maintenance'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <MajorMaintenanceResolution :mode="mode" v-else-if="issue_type == 'major_maintenance'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <RoutineMaintenanceResolution :mode="mode" v-else-if="issue_type == 'routine_maintenance'" :issue.sync="issue" :api_errors="api_errors" 
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <RoadUserAccidentResolution :mode="mode" v-else-if="issue_type == 'road_user_accident'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <OccupationalResolution :mode="mode" v-else-if="issue_type == 'occupational'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <DeadAnimalDebrisRemovalResolution :mode="mode" v-else-if="issue_type == 'dead_animal_debris_removal'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <VehicleBreakdownResolution :mode="mode" v-else-if="issue_type == 'vehicle_breakdown'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <TrafficViolationResolution :mode="mode" v-else-if="issue_type == 'traffic_violation'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <UnauthorisedParkingResolution :mode="mode" v-else-if="issue_type == 'unauthorised_parking'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <UnauthorisedAccessResolution :mode="mode" v-else-if="issue_type == 'unauthorised_access'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <UnauthorisedMedianCutResolution :mode="mode" v-else-if="issue_type == 'unauthorised_media_cut'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <MaterialDamageResolution :mode="mode" v-else-if="issue_type == 'material_damage'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <OtherResolution :mode="mode" v-else-if="issue_type == 'other'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
                <EnroachmentRowResolution :mode="mode" v-else-if="issue_type == 'enroachment_row'" :issue.sync="issue" :api_errors="api_errors"
                    :manager_dropdown="manager_dropdown" :editResolution="editResolution" :editExternalResolution="editExternalResolution"
                />
    
                <vs-row class="mt-base" v-if="(mode == 'e' && (this.editResolution || this.editExternalResolution))">
                    <vs-col class="text-center">
                        <vs-button @click="save" :disabled="submit_disabled">
                            Save
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-base" v-if="show_action_buttons">
                    <vs-col class="text-center" v-if="reviewResolution || reviewExternalResolution">
                        <vs-button @click="reject" type="filled" color="primary" class="mx-2">
                            Reject
                        </vs-button>
                        <vs-button @click="approve" type="filled" color="primary" class="mx-2">
                            Approve
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vx-card>
            <RejectionPopup :is_active.sync="reject_popup.active" :api_errors="reject_popup.api_errors" :submit="do_reject" />
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>
import { Request } from "../../utils/requests";
import HighwayResolution from "./Highway/HighwayResolution.vue";
import HazardResolution from "./Hazard/HazardResolution.vue";
import ElectricalMaintenanceResolution from "./ElectricalMaintenance/ElectricalMaintenanceResolution.vue";
import MajorMaintenanceResolution from "./MajorMaintenance/MajorMaintenanceResolution.vue";
import RoutineMaintenanceResolution from "./RoutineMaintenance/RoutineMaintenanceResolution.vue";
import RoadUserAccidentResolution from "./RoadUserAccident/RoadUserAccidentResolution.vue";
import OccupationalResolution from "./Occupational/OccupationalResolution.vue";
import DeadAnimalDebrisRemovalResolution from "./DeadAnimalDebrisRemoval/DeadAnimalDebrisRemovalResolution.vue";
import VehicleBreakdownResolution from "./VehicleBreakDown/VehicleBreakdownResolution.vue";
import TrafficViolationResolution from "./TrafficViolation/TrafficViolationResolution.vue";
import UnauthorisedParkingResolution from "./UnauthorisedParking/UnauthorisedParkingResolution.vue"
import UnauthorisedAccessResolution from "./UnauthorisedAccess/UnauthorisedAccessResolution.vue";
import UnauthorisedMedianCutResolution from "./UnauthorisedMedianCut/UnauthorisedMedianCutResolution.vue";
import MaterialDamageResolution from "./MaterialDamage/MaterialDamageResolution.vue";
import OtherResolution from "./Other/OtherResolution.vue";
import EnroachmentRowResolution from "./EnroachmentRow/EnroachmentRowResolution.vue";

import RejectionPopup from "./Components/RejectionPopup.vue";
import moment from "moment";

export default {
    data() {
        return {
            issue_id: this.$route.params.issue_id,
            issue_type: this.$route.params.issue_type,

            loading: true,

            issue: null,

            submit_disabled: false,
            api_errors: {},
            reject_popup: {
                active: false,
                api_errors: {}
            }
        }
    },
    computed: {
        mode () {
            if (!this.issue || (this.issue.resource_allocation == 'e' && this.issue.resolution_status_se == 'r') || !this.issue.resolution_status || this.issue.resolution_status == 'r') return 'e'
            return 'v'
        },
        show_action_buttons () {
            if (this.mode != 'v') return false

            if (this.issue.resolution_status == 'a') return false

            // resource allocation external and resolution_status_se is not approved and user is assigned_reviewers then buttons should not be visible to assigned_reviewers
            if (this.issue.resource_allocation == 'e' && this.issue.resolution_status_se != 'a' && this.issue.assigned_reviewers.map(v=>v.id).includes(this.$store.state.organisation.organisation_user.id)) return false

            // resource allocation external and resolution_status_se is not pending and user is allocated engineer then buttons should not be visible to allocated engineer.
            if (this.issue.resource_allocation == 'e' && this.issue.resolution_status_se != 'p' && this.issue.allocated_engineer.id == this.$store.state.organisation.organisation_user.id) return false

            return true
        },
        viewIssue() {
            let user_ids = this.issue.assigned_reviewers.map(v=>v.id)
            user_ids.push(this.issue.reported_by.id)
            return this.hasAccess('read', `issue_${this.issue_type}`, 'any', user_ids)
        },
        viewResolution() {
            return this.hasAccess('read_resolution', `issue_${this.issue_type}`, ['all', 'assigned'], [this.issue.allocated_engineer.id])
        },
        editResolution() { 
            return this.issue.resource_allocation == 'i' && this.hasAccess('edit_resolution', `issue_${this.issue_type}`, ['all', 'assigned'], [this.issue.allocated_engineer.id]) 
        },
        // checking issue is external and it have read external resolution permission
        viewExternalResolution() {
            return this.issue.resource_allocation == 'e' && this.hasAccess('read_external_resolution', `issue_${this.issue_type}`, ['all', 'assigned'], [this.issue.allocated_resource.id])
        },
        // checking issue is external and it have edit external resolution permission
        editExternalResolution() { 
            return this.issue.resource_allocation == 'e' && this.hasAccess('edit_external_resolution', `issue_${this.issue_type}`, ['all', 'assigned'], [this.issue.allocated_resource.id]) 
        },
        reviewResolution() { 
            return this.hasAccess('review_resolution', `issue_${this.issue_type}`, ['all', 'assigned'], this.issue.assigned_reviewers.map(v=>v.id)) 
        },
        // checking issue is external and it have review permission
        reviewExternalResolution() { 
            return this.issue.resource_allocation == 'e' && this.hasAccess('review_external_resolution', `issue_${this.issue_type}`, ['all', 'assigned'], [this.issue.allocated_engineer.id]) 
        },
        hasPermission() {
            return (this.editResolution || this.editExternalResolution || this.viewResolution || this.viewExternalResolution || this.viewIssue)
        }
    },
    watch: {
        "$route.params.issue_type"(newV, oldV) {
            if (newV == oldV)
                return;
            this.init();
        },
        "$route.params.issue_id"(newV, oldV) {
            if (newV == oldV)
                return;
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.issue_type = this.$route.params.issue_type
            this.issue_id = this.$route.params.issue_id

            if (this.issue_id) this.load_data()
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.data_issue + this.issue_id + "/"

            this.$vs.loading()
            this.loading = true

            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.loading = false
                    if (res.status != 'a') {
                        return this.$router.push({name: 'issues-list', params: {issue_type: this.issue_type}})
                    }
                    this.issue = res
                    if (!this.issue.resolution_started_on)
                        this.issue.resolution_started_on = moment().format('YYYY-MM-DD')
                },
                err => {
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let payload = {
                action: 'submit_resolution',
                resolution_description: this.issue.resolution_description
            }

            this.api_errors = {}

            if (this.issue.images.length == 0 || (
                this.issue.images.filter(v => v.image_type == 'w').length == 0
                && this.issue.images.filter(v => typeof(v.image) != 'string').length == 0)
             ) {
                this.api_errors = {
                    "images": [
                        "Please select atleast 1 image",
                    ]
                }
                this.$vs.notify({
                    time: 3000,
                    title: 'Error',
                    text: "Please fix the errors and try again!",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
                return
            }

            this.submit_disabled = true
            this.$vs.loading()

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.data_issue_action, this.issue.id), null, payload).then(
                async () => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    await this.upload_images(this.issue_id)

                    this.$router.push({name: 'issues-list', params: {issue_type: this.issue_type}})

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        async upload_images(issue_id) {
            for (let i=0; i < this.issue.images.length; i++) {
                this.$set(this.issue.images[i], 'status', 'u')
                try {
                    let data = await this.upload_single_image(issue_id, this.issue.images[i])
                    this.$set(this.issue.images[i], 'status', 'c')
                    if (data != null)
                        this.$set(this.issue.images, i, data)
                } catch (e) {
                    this.$set(this.issue.images[i], 'status', 'f')
                    throw e
                }
            }
        },
        async upload_single_image(issue_id, image_obj) {

            return new Promise( (resolve, reject) => {
                if (typeof(image_obj.image) == 'string') resolve(null)

                let payload = new FormData()
                payload.append('image', image_obj.image)
                payload.append('image_type', 'w')

                Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.data_issue_image, issue_id), null, payload).then(
                    res => resolve(res),
                    err => reject(err)
                )

            })
        },
        do_reject(data) {
            let payload = {
                action: 'reject_resolution',
                resolution_comment: data.comment
            }

            this.submit_disabled = true
            this.$vs.loading()
            this.reject_popup.api_errors = {}

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.data_issue_action, this.issue_id), null, payload).then(
                () => {
                    this.$vs.loading.close()
                    this.submit_disabled = false
                    this.reject_popup.active = false
                    this.reject_popup.api_errors = {}

                    this.$router.push({name: 'issues-list', params: {issue_type: this.issue_type}})

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    if (err.error) {
                        this.reject_popup.api_errors = err.error
                        if (this.reject_popup.api_errors.resolution_comment)
                            this.reject_popup.api_errors.comment = this.reject_popup.api_errors.resolution_comment
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.reject_popup.active = false
                    }
                }
            )
        },
        approve() {
            let payload = {
                action: 'approve_resolution'
            }

            this.submit_disabled = true
            this.$vs.loading()

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.data_issue_action, this.issue_id), null, payload).then(
                () => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    this.$router.push({name: 'issues-list', params: {issue_type: this.issue_type}})

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        reject () {
            this.reject_popup.active = true
        },
        manager_dropdown() {
            let permission = []
            permission.push(`review__all__issue_${this.issue_type}`)
            permission.push(`review__assigned__issue_${this.issue_type}`)

            return permission.toString()
        }
    },
    components: { HighwayResolution, HazardResolution, ElectricalMaintenanceResolution, MajorMaintenanceResolution, RoutineMaintenanceResolution,  RejectionPopup,
        RoadUserAccidentResolution, OccupationalResolution, DeadAnimalDebrisRemovalResolution, VehicleBreakdownResolution, TrafficViolationResolution,
        UnauthorisedParkingResolution, UnauthorisedAccessResolution, UnauthorisedMedianCutResolution, MaterialDamageResolution, OtherResolution,
        EnroachmentRowResolution }
}
</script>
